import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewDeviceId } = appStoreLenses

export default state => viewDeviceId(state)
